export const headingClassName = {
  color: {
    light: "text-base-01",
    dark: "text-base-02",
    blue: "text-dark-blue",
  },
  size: {
    xxxlarge: "text-5xl md:text-7xl xl:text-8xl",
    xxlarge: "text-3xl md:text-4xl xl:text-6xl",
    xlarge: "text-3xl xl:text-4xl",
    large: "text-2xl xl:text-3xl",
    medium: "text-lg md:text-2xl",
    small: "text-base md:text-lg", // changed text-sm to text-base in difference to design (design is wrong IMHO - smallest heading should not be smaller than body text)
  },
  weight: {
    normal: "font-normal",
    bold: "font-medium",
  },
};

// HTML tag matched by size, if 'tag' is omitted.
export const headingTag = {
  xxxlarge: "h1",
  xxlarge: "h2",
  xlarge: "h3",
  large: "h4",
  medium: "h5",
  small: "h6",
};
